import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../lib/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'rose' | 'outline';
  size?: 'lg' | 'md';
  className?: string;
}
export function CtaButton({
  children,
  href,
  variant = 'rose',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl font-extrabold uppercase tracking-wide transition-[background-color,color,transform,box-shadow] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--rose)]/35 active:scale-[0.98]';
  const sizes = {
    lg: 'px-6 py-4 text-base sm:text-lg',
    md: 'px-5 py-3 text-sm sm:text-base'
  };
  const variants = {
    rose: 'bg-[var(--rose)] text-[var(--bg-deep)] hover:bg-[#dba7a9] shadow-[0_16px_36px_-18px_rgba(205,146,149,0.9)]',
    outline: 'border-2 border-[var(--slate)] bg-transparent text-[var(--text)] hover:bg-[var(--slate)]/15'
  };
  const content = <>
      <span data-id="element-57" data-mp="35zijo6g9jqme">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-58" data-mp="39y7zs6sorm9q" />
    </>;
  if (href) {
    return <a href={href} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: String(children)
    })} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-59" data-mp="3jxgp2mclwcpr">
        {content}
      </a>;
  }
  return <button type="button" className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-60" data-mp="1ixxoyosqh1y">
      {content}
    </button>;
}